import { render, staticRenderFns } from "./EditAttributes.vue?vue&type=template&id=367f8e88"
import script from "./EditAttributes.vue?vue&type=script&lang=js"
export * from "./EditAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports